import { render, staticRenderFns } from "./PromoHeaderBanner.vue?vue&type=template&id=c132f554&scoped=true"
import script from "./PromoHeaderBanner.vue?vue&type=script&lang=js"
export * from "./PromoHeaderBanner.vue?vue&type=script&lang=js"
import style0 from "./PromoHeaderBanner.vue?vue&type=style&index=0&id=c132f554&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c132f554",
  null
  
)

export default component.exports